import * as api from '../_api';

/**
 * The events lambda answers invalid input with 400 { error: '<German message>' }.
 */
function errorMessage(err: any) {
  if (err && err.response && err.response.data) {
    const { data } = err.response;
    if (data.error) {
      return data.error;
    }
    if (data.message) {
      return data.message;
    }
  }
  return err && err.message ? err.message : err;
}

// @ts-ignore
export const create = async ({ dispatch }, one) => {
  try {
    await api.create(one);
    dispatch('snackbar/success', 'Netzwerktreffen wurde erstellt', { root: true });
    return true;
  } catch (err) {
    dispatch('snackbar/warning', errorMessage(err), { root: true });
    return false;
  }
};

// @ts-ignore
export const read = async ({ commit, dispatch }) => {
  try {
    const all = await api.read();
    commit('setAll', all);
    return true;
  } catch (err) {
    dispatch('snackbar/warning', errorMessage(err), { root: true });
    return false;
  }
};

// @ts-ignore
export const readOne = async ({ commit, dispatch }, { id }) => {
  try {
    const one = await api.readOne(id);
    commit('setOne', one);
    return true;
  } catch (err) {
    dispatch('snackbar/warning', errorMessage(err), { root: true });
    return false;
  }
};

// @ts-ignore
export const update = async ({ dispatch }, { id, data }) => {
  try {
    await api.update(id, data);
    dispatch('snackbar/success', 'Änderungen wurden gespeichert', { root: true });
    return true;
  } catch (err) {
    dispatch('snackbar/warning', errorMessage(err), { root: true });
    return false;
  }
};

// @ts-ignore
export const remove = async ({ dispatch }, { id }) => {
  try {
    await api.remove(id);
    dispatch('snackbar/success', 'Netzwerktreffen wurde gelöscht', { root: true });
    return true;
  } catch (err) {
    dispatch('snackbar/warning', errorMessage(err), { root: true });
    return false;
  }
};
